import { render, staticRenderFns } from "./GlobalSearchProviders.vue?vue&type=template&id=19d332fa&"
import script from "./GlobalSearchProviders.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchProviders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports